export const EMAIL_ADDRESS = "info@randrpartners.com.au";
export const WEBSITE_NAME = "R&R Partners";
export const PHONE_NUMBER = "+61 422 399 015";
export const POSTAL_ADDRESS = "PO Box 4334 Knox City Centre VIC 3152 Australia";
